module.exports = __webpack_public_path__ + "static/img/y8.3f2dfce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/y8.png
// module id = F1X8
// module chunks = 1